var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfiltration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3455 18.6112H13.509V16.4014H10.0183V18.6112H11.1819C11.1819 22.7289 12.3455 20.5604 12.3455 18.6112Z",
    fill: "#06D7F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8785 10.0152C13.6491 10.5979 12.1753 10.5116 11.0316 9.78752C10.0902 9.19134 8.84757 9.2232 7.94251 9.86899L6.52783 10.8763V13.9342L8.67886 15.296H14.849L17 13.9342V9.00781L14.8785 10.0152Z",
    fill: "#06D7F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4021 4.24667C13.4673 4.07301 13.5093 3.88882 13.5093 3.69421C13.5093 2.78029 12.7264 2 11.7639 2C10.8015 2 10.0186 2.78029 10.0186 3.69421C10.0186 3.88882 10.0605 4.07301 10.1257 4.24667H6.52783V9.49538L7.24428 8.9852C8.54194 8.05832 10.3242 8.01139 11.677 8.86811C12.4747 9.3731 13.5025 9.43354 14.3581 9.02674L17 7.77225V4.24667H13.4021Z",
    fill: "#06D7F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 1.5,
    height: 5,
    fill: "#06D7F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiltration);
export default __webpack_public_path__ + "static/media/infiltration.b3853de838009963631cc5320855eb0a.svg";
export { ForwardRef as ReactComponent };